export var PORT_MAP = new WeakMap();